import { NotificationFilter, NotificationList } from '../../services/types/Notification';
import { Action, ApiState } from '../../types';
import { callService, serviceReducer } from '../../shared/hooks/serviceReducer';

export type NotificationAction =
  | Action<NotificationList, NotificationFilter>
  | { type: 'PAGE'; value: number }
  | { type: 'ORDER'; column: string; descending: boolean };

const reducer = (
  state: ApiState<NotificationList, NotificationFilter>,
  action: NotificationAction
): ApiState<NotificationList, NotificationFilter> => {
  switch (action.type) {
    case 'PAGE':
      return callService(state, { ...state.filter, pageNumber: action.value });
    case 'ORDER':
      return callService(state, {
        ...state.filter,
        pageNumber: 1,
        sortField: action.column,
        sortDescending: action.descending,
      });
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
